import BaseModel from "./BaseModel";
import User from "./User";

export default class Notification extends BaseModel {

	static entity = 'notifications';
	static route = 'notifications';
	static plural = 'notifications';
	static singular = 'notification';

	static fields () {
		return {
			id: this.attr(null),
			type: this.attr(null),
			notifiable_type: this.attr(null),
			notifiable_id: this.attr(null),
			data: this.attr(null, (value) => typeof value === 'string' ? JSON.parse(value) : value),
			read_at: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			user: this.belongsTo(User, 'notifiable_id', 'id'),
		}
	}

	static configureApi() {
		let config = super.configureApi();
		config.headers = {'Content-Type': 'multipart/form-data'};
		config.actions.view = function(id) {
			return this.get('/'+this.model.route+'/'+id+'/view', {
				dataTransformer: () => {
					return [];
				}
			});
		};
		config.actions.example = function(type) {
			return this.get('/'+this.model.route+'/example/'+type, {
				dataTransformer: () => {
					return [];
				}
			});
		};
		config.actions.general = function(message, title, emails) {
			return this.post('/'+this.model.route+'/general', {message, title, emails}, {
				dataTransformer: () => {
					return [];
				}
			});
		};
		return config;
	}

	static apiConfig = this.configureApi();

}
